import { render, staticRenderFns } from "./Mp3Player.vue?vue&type=template&id=321ef84b&scoped=true&"
import script from "./Mp3Player.vue?vue&type=script&lang=js&"
export * from "./Mp3Player.vue?vue&type=script&lang=js&"
import style0 from "./Mp3Player.vue?vue&type=style&index=0&id=321ef84b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321ef84b",
  null
  
)

export default component.exports